import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';

// Component
import StaticPageManagement from '../../../components/siteadmin/StaticPageManagement/StaticPageManagement';

import s from './StaticPage.css';

const StaticPage = (props) => {

    const { title } = props;

    return (
        <StaticPageManagement
            title={title}
        />
    );
}

StaticPage.propTypes = {
    title: PropTypes.string.isRequired,
    data: PropTypes.shape({
        loading: PropTypes.bool,
        getBlogParentPage: PropTypes.any,
    })
};

StaticPage.defaultProps = {
    data: {
        loading: true
    }
};

export default compose(
    withStyles(s),
)(StaticPage);